import { render } from "./index.vue?vue&type=template&id=0f663fbe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0f663fbe&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0f663fbe"

export default script